// import Cookies from 'js-cookie';
import { REHYDRATE } from 'redux-persist/es/constants';
import * as types from './actionTypes';

const initState = {
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const ProfileReducer = (state = initState, action) => {
  const { type } = action;
  switch (type) {
    case REHYDRATE:
      return {
        ...state,
        ...(action.payload?.profile || {}),
        loading: false,
      };
    case types.UPDATE_PROFILE:
      return {
        ...state,
        loading: true,
      };
    case types.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.UPDATE_PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
export default ProfileReducer;
